// extracted by mini-css-extract-plugin
module.exports = {"diffViewerStyle":"diffViewer_diffViewerStyle__FX0Er","diffViewerWidth":"diffViewer_diffViewerWidth__3Ss9I"};